import React from "react";
import { Link } from "react-router-dom";
import './Card.css';

export const AppComponent = () => {
  const data = [
    {
      id: "01",
      link: "https://dluongta.github.io/",
      linkName: "General Intoduce Page",
    },
    {
      id: "02",
      link: "https://the-digital-shop.onrender.com",
      linkName: "The Shop",
    },
    {
      id: "03",
      link: "https://github.com/luen2003/NoteApp/releases/download/v1.0.0/app-release.apk",
      linkName: "Note App",
    },
    {
      id: "04",
      link: "https://github.com/luen2003/NewsApp/releases/download/v1.0.0/app-release.apk",
      linkName: "News App",
    },
    {
      id: "05",
      link: "https://github.com/luen2003/python-code",
      linkName: "Python Code",
    },
    {
      id: "06",
      link: "https://dluongta.github.io/qr-scanner.html",
      linkName: "QRCode Scanner",
    },
    {
      id: "07",
      link: "https://react-app-videocall.onrender.com/",
      linkName: "Voice Or Video Call Using WebRTC",
    },
    {
      id: "08",
      link: "https://dluongta.github.io/qr-generator.html",
      linkName: "QRCode Generator",
    },
    {
      id: "09",
      link: "https://react-app-google-login-page.vercel.app/",
      linkName: "React App Google Login Page",
    },
    {
      id: "10",
      link: "https://dluongta.github.io/pdf-excel-generator.html",
      linkName: "PDF And Excel Generator",
    },
    {
      id: "11",
      link: "https://react-livestream-app.onrender.com/",
      linkName: "React Livestream App",
    },
    {
      id: "12",
      link: "https://dluongta.github.io/text_speech.html",
      linkName: "Text Speech",
    },
    {
      id: "13",
      link: "https://dluongta.github.io/quiz-app.html",
      linkName: "Quiz App",
    },
    {
      id: "14",
      link: "https://dluongta.github.io/digital-calendar.html",
      linkName: "Digital Calendar",
    },
    {
      id: "15",
      link: "https://dluongta.github.io/caculator.html",
      linkName: "Caculator",
    },
    {
      id: "16",
      link: "https://github.com/luen2003/ASPNET_API",
      linkName: "ASPNET API",
    },
    {
      id: "17",
      link: "https://shootingtankio.onrender.com/",
      linkName: "Shooting Tank IO",
    },
    {
      id: "18",
      link: "https://dluongta.github.io/image_editor/index.html",
      linkName: "Image Editor",
    },
    {
      id: "19",
      link: "https://dluongta.github.io/upload_avatar.html",
      linkName: "Upload Avatar",
    },
    {
      id: "20",
      link: "https://react-app-bank-code.vercel.app/",
      linkName: "Confirm Payment",
    },
    {
      id: "21",
      link: "https://github.com/luen2003/mysql-api",
      linkName: "NodeJS MySQL API",
    },
    {
      id: "22",
      link: "https://github.com/luen2003/php-mysql-api",
      linkName: "PHP MySQL API",
    },
    {
      id: "23",
      link: "https://dluongta.github.io/flipbook3d.html",
      linkName: "3D Flip Book",
    },
    {
      id: "24",
      link: "https://dluongta.github.io/text_image.html",
      linkName: "Text Image",
    },
    {
      id: "25",
      link: "https://dluongta.github.io/voice_recording.html",
      linkName: "Voice Recording",
    },
    {
      id: "26",
      link: "https://dluongta.github.io/video_recording.html",
      linkName: "Video Recording",
    },
    {
      id: "27",
      link: "https://dluongta.github.io/spin_wheel.html",
      linkName: "Spin Wheel",
    },
    {
      id: "28",
      link: "https://github.com/luen2003/WeatherApp/releases/download/v1.0.0/app-release.apk",
      linkName: "Weather App",
    },
    {
      id: "29",
      link: "https://dluongta.github.io/vn-telex-input.html",
      linkName: "VN Telex Input",
    },
    {
      id: "30",
      link: "https://github.com/luen2003/SDL_GAME/archive/refs/tags/v1.0.0.zip",
      linkName: "SDL Game",
    },
    {
      id: "31",
      link: "https://github.com/luen2003/face-recognition-app/releases/download/v1.0.0/FaceRecognitionApp.exe",
      linkName: "Face Recognition App",
    },
    {
      id: "32",
      link: "https://github.com/luen2003/face-recognition-app-web/releases/download/v1.0.0/FaceRecognitionAppWeb.exe",
      linkName: "Face Recognition App Web",
    },
    {
      id: "33",
      link: "https://dluongta.github.io/image-framer-studio.html",
      linkName: "Image Framer Studio",
    },
    {
      id: "34",
      link: "https://dluongta.github.io/web_preview.html",
      linkName: "Web Preview",
    },
    {
      id: "35",
      link: "https://github.com/luen2003/VNKey/releases/download/v1.0.0/VNKey.exe",
      linkName: "VNKey",
    }
  ];
  return (
    <>
      <section className="portfolio">
        <div className="cards-wrapper">
          {data.map((value) => {
            return (
              <div key={value.id} className="basic-card card">
                <div className="card-content">
                  <h1>{value.linkName}</h1>
                </div>
                <a
                  className="link"
                  href={value.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &rarr; {value.link}
                </a>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};